module.exports = {
  ShapeOverlay: {
    PluginName: "Forma Superpuesta",
    Shape: "Forma",
    Type: "Tipo",
    Color: "Color",
  },
};
